import { ConstructableView } from './types';
import NovenaShow from 'js/views/novena/show';
import PasswordResetEmailForm from 'js/views/password_reset/email-form';
import PreviewShow from 'js/views/preview/show';
import ProfileChangeEmail from 'js/views/profile/change-email';
import SessionNew from 'js/views/session/new';
import UserNew from 'js/views/user/new';
import UserNovenaEdit from 'js/views/user_novena/edit';
import UserNovenaInviteIndex from 'js/views/user_novena_invite/index';
import UserNovenaInviteShow from 'js/views/user_novena_invite/show';
import UserNovenaNew from 'js/views/user_novena/new';
import UserNovenaShow from 'js/views/user_novena/show';
import UserNovenaSocial from 'pmn/views/user_novena/social';

export const appViews: Record<string, ConstructableView> = {
  NovenaShow,
  PasswordResetEmailForm,
  PreviewShow,
  ProfileChangeEmail,
  SessionNew,
  UserNew,
  UserNovenaEdit,
  UserNovenaInviteIndex,
  UserNovenaInviteShow,
  UserNovenaNew,
  UserNovenaShow,
  UserNovenaSocial,
};
